import { render, staticRenderFns } from "./BloquePromociones.vue?vue&type=template&id=5ba533a6&scoped=true"
import script from "./BloquePromociones.vue?vue&type=script&lang=js"
export * from "./BloquePromociones.vue?vue&type=script&lang=js"
import style0 from "./BloquePromociones.vue?vue&type=style&index=0&id=5ba533a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba533a6",
  null
  
)

export default component.exports